import { getAudioParamConnections } from './get-audio-param-connections';
export function getAudioParamRenderer(context, audioParam) {
    const audioParamConnections = getAudioParamConnections(context, audioParam);
    if (audioParamConnections.renderer === null) {
        throw new Error('Missing the renderer of the given AudioParam in the audio graph.');
    }
    return audioParamConnections.renderer;
}
//# sourceMappingURL=/build/es2018/helpers/get-audio-param-renderer.js.map